import classNames from 'classnames';
import React from 'react';
import { Badge, Nav } from 'react-bootstrap';
import useBreakpoint from '../../hooks/useBreakpoint';
import './NavLink.scss';

const NavLink = ({ text, className, icon, badge, to, ...params }) => {
  const breakpoint = useBreakpoint();
  return (
    <Nav.Link
      className={classNames('NavLink', className)}
      to={to}
      {...params}>
      <div className={classNames("btn btn-tertiary align-items-center", {
        icon: breakpoint !== 'xs' && icon,
        'justify-content-center': breakpoint !== 'xs' && icon,
        'justify-content-between': !icon || breakpoint === 'xs'
      })}>
        <span>
          {/* If there's icon and text, shows text only if it's mobile */}
          {icon && (breakpoint !== 'xs' || !text) ? icon : text}
          {/* Shows badge when text and no icon */}
          {((breakpoint === 'xs' && text) || !icon) && badge
            ? <Badge className="m-0 ml-2" variant="dark">{badge}</Badge>
            : null}
        </span>

        {/* Shows an arrow when text and it's mobile */}
        {
          breakpoint === 'xs' && text && to
            ? <i className="fal fa-arrow-right ml-2" />
            : null
        }
      </div>
      {/* Shows badge when icons it's active */}
      {icon && badge && <Badge className="m-0 ml-2" variant="dark">{badge}</Badge>}
    </Nav.Link >
  );
};

export default NavLink;